import { useState } from "react";

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
            >
              <span
                className={`font-heading text-sm md:text-base font-bold transition-colors ${
                  isOpen ? "text-primary-700" : "text-foreground-950 group-hover:text-primary-700"
                }`}
              >
                {item.q}
              </span>
              <span
                className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-full border text-sm transition-colors ${
                  isOpen
                    ? "border-primary-300 bg-primary-100 text-primary-700"
                    : "border-background-300 text-foreground-500"
                }`}
              >
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
              </span>
            </button>
            {isOpen && (
              <div className="pb-5 pr-10 -mt-1">
                <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}